import { AxiosResponse } from 'axios'
import { PaginationList } from 'types/common'
import { api } from 'API'
import {
  ICompanyReport,
  ICompanyReportPayload,
  ICompanyReportTable,
  IReportAction,
  IReportActionPayload,
  IReportActionTable,
  IReportCollectionPayload,
  IReportCollectionResponse,
  IReportDetailPayload,
  IReportDetail,
  IReportGeneralPayload,
  IReportGeneralResponse,
  IReportGroup,
  IReportGroupPayload,
  IReportGroupTable,
  IReportProcessPayload,
  IReportProcessResponse,
  ICompanyDetail
} from 'constants/report'
import { IReportCollectionTable } from 'interfaces/collection'
import { IOrganization } from 'interfaces/organization'
import { IReportProcessTable } from 'interfaces/process'

const REPORT_URL = '/reports'
const ADMIN_REPORT_URL = '/admin-reports'

export async function getReportGeneral(
  organizationId: number,
  payload: IReportGeneralPayload
): Promise<IReportGeneralResponse> {
  const response: AxiosResponse = await api.post(`${REPORT_URL}/${organizationId}/general`, payload)
  return response.data
}

export async function getReportProcess(
  organizationId: number,
  payload: IReportProcessPayload
): Promise<IReportProcessResponse> {
  const response: AxiosResponse = await api.post(`${REPORT_URL}/${organizationId}/process`, payload)
  return response.data
}

export async function getReportProcessTable(
  organizationId: number,
  payload: IReportProcessPayload
): Promise<PaginationList<IReportProcessTable>> {
  const response: AxiosResponse = await api.post(`${REPORT_URL}/${organizationId}/process/table`, payload)
  return response.data
}
export async function getExportReportProcessTable(
  organizationId: number,
  payload: IReportProcessPayload
): Promise<PaginationList<IReportProcessTable>> {
  const response: AxiosResponse = await api.post(`${REPORT_URL}/${organizationId}/process/table`, payload)
  return response.data
}

export async function getReportGroups(organizationId: number, payload: IReportGroupPayload): Promise<IReportGroup> {
  const response: AxiosResponse = await api.post(`${REPORT_URL}/${organizationId}/group`, payload)
  return response.data
}

export async function getReportGroupsTable(
  organizationId: number,
  payload: IReportGroupPayload
): Promise<PaginationList<IReportGroupTable>> {
  const response: AxiosResponse = await api.post(`${REPORT_URL}/${organizationId}/group/table`, payload)
  return response.data
}

export async function getReportCollection(
  organizationId: number,
  payload: IReportCollectionPayload
): Promise<IReportCollectionResponse> {
  const response: AxiosResponse = await api.post(`${REPORT_URL}/${organizationId}/collection`, payload)
  return response.data
}

export async function getReportCollectionTable(
  organizationId: number,
  payload: IReportCollectionPayload
): Promise<PaginationList<IReportCollectionTable>> {
  const response: AxiosResponse = await api.post(`${REPORT_URL}/${organizationId}/collection/table`, payload)
  return response.data
}

export async function getReportAction(organizationId: number, payload: IReportActionPayload): Promise<IReportAction> {
  const response: AxiosResponse = await api.post(`${REPORT_URL}/${organizationId}/action`, payload)
  return response.data
}

export async function getReportActionTable(
  organizationId: number,
  payload: IReportActionPayload
): Promise<PaginationList<IReportActionTable>> {
  const response: AxiosResponse = await api.post(`${REPORT_URL}/${organizationId}/action/table`, payload)
  return response.data
}

export async function getCompanyReport(payload: ICompanyReportPayload): Promise<ICompanyReport> {
  const response = await api.post(`${ADMIN_REPORT_URL}/organization`, payload, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `HowFactory!2024@ABC`
    }
  })
  return response.data
}

export async function getCompanyReportTable(
  payload: ICompanyReportPayload
): Promise<PaginationList<ICompanyReportTable>> {
  const response = await api.post(`${ADMIN_REPORT_URL}/organization/table`, payload, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: sessionStorage?.getItem('adminPassword') || ''
    }
  })
  return response.data
}

export async function getCompanyReportDetail(id: number, payload: IReportGeneralPayload): Promise<ICompanyDetail> {
  const response = await api.post(`${ADMIN_REPORT_URL}/organization/detail/${id}`, payload, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: sessionStorage?.getItem('adminPassword') || ''
    }
  })
  return response.data
}

export async function updateAdminOrganizationById(organizationId: number, data: Partial<IOrganization>): Promise<void> {
  await api.patch(`${ADMIN_REPORT_URL}/organizations/${organizationId}`, data, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: sessionStorage?.getItem('adminPassword') || ''
    }
  })
}

export async function getReportProcessDetail(
  organizationId: number,
  processId: number,
  payload: IReportDetailPayload
): Promise<IReportDetail> {
  const response = await api.post(`${REPORT_URL}/${organizationId}/process/${processId}`, payload)
  return response.data
}

export async function getReportCollectionDetail(
  organizationId: number,
  collectionId: number,
  payload: IReportDetailPayload
): Promise<IReportDetail> {
  const response = await api.post(`${REPORT_URL}/${organizationId}/collection/${collectionId}`, payload)
  return response.data
}

export async function getReportGroupDetail(
  organizationId: number,
  groupId: number,
  payload: IReportDetailPayload
): Promise<IReportDetail> {
  const response = await api.post(`${REPORT_URL}/${organizationId}/group/${groupId}`, payload)
  return response.data
}
